// tslint:disable: max-line-length
// third party imports
import { CommonModule, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { TransferHttpCacheModule } from '@nguniversal/common';
import localeFi from '@angular/common/locales/fi';
import { NguCarouselModule } from '@ngu/carousel';
import {
  SwiperConfigInterface,
  SwiperModule,
  SWIPER_CONFIG,
} from 'ngx-swiper-wrapper';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiSwitchModule } from 'ngx-toggle-switch';
// import { CookieService } from 'ngx-cookie-service';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';

// app impports
// import { environment } from '../environments/environment';
import { OldViewRoutingModule } from './old-view-routing.module';
import { OldViewComponent } from './old-view.component';

// page imports
import { CheckoutJoinComponent } from './pages/checkout-join/checkout-join.component';
import { CheckoutLoginComponent } from './pages/checkout-login/checkout-login.component';
import { CheckoutPayComponent } from './pages/checkout-pay/checkout-pay.component';
import { CheckoutThankYouComponent } from './pages/checkout-thank-you/checkout-thank-you.component';
import { LoginComponent } from './pages/login/login.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { RegisterComponent } from './pages/register/register.component';
import { ResultComponent } from './pages/result/result.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { TestIntroComponent } from './pages/test-intro/test-intro.component';
import { ShareResultComponent } from './pages/share-result/share-result.component';
import { InternationalTestComponent } from './pages/international-test/international-test.component';
import { UserManagementComponent } from './pages/user-management/user-management.component';

// component imports
import { CheckoutSidebarComponent } from './components/checkout-sidebar/checkout-sidebar.component';
import { ChoosePlanComponent } from './components/choose-plan/choose-plan.component';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { CurrentPlanComponent } from './components/current-plan/current-plan.component';
import { FaqComponent } from './components/faq/faq.component';
import { HeroProfileComponent } from './components/hero-profile/hero-profile.component';
import { HeroResultsComponent } from './components/hero-results/hero-results.component';
import { HeroComponent } from './components/hero/hero.component';
import { HeroImpactComponent } from './components/hero-impact/hero-impact.component';
import { HowCompensateWorksComponent } from './components/how-compensate-works/how-compensate-works.component';

import { JoinComponent } from './components/join/join.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { PayComponent } from './components/pay/pay.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignOutComponent } from './components/sign-out/sign-out.component';
import { TestResultCategoryChartComponent } from './components/test-result-category-chart/test-result-category-chart.component';
import { TestResultProfileComponent } from './components/test-result-profile/test-result-profile.component';
import { TitleAndIngressBannerComponent } from './components/title-and-ingress-banner/title-and-ingress-banner.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { SitraBannerComponent } from './components/sitra-banner/sitra-banner.component';
import { DefaultPaymentMethodComponent } from './components/default-payment-method/default-payment-method.component';
import { SettingsSubscriptionComponent } from './components/settings-subscription/settings-subscription.component';
import { HeroImageAndTitleComponent } from './components/hero-image-and-title/hero-image-and-title.component';
import { IconTitleIngressAndCtaComponent } from './components/icon-title-ingress-and-cta/icon-title-ingress-and-cta.component';
import { InviteComponent } from './components/invite/invite.component';
import { ShareLinkComponent } from './components/share-link/share-link.component';
import { SettingsYourInformationComponent } from './components/settings-your-information/settings-your-information.component';
import { InvitedByComponent } from './components/invited-by/invited-by.component';
import { QuestionComponent } from './components/international-test/question/question.component';
import { ChartComponent } from './components/international-test/chart/chart.component';
import { SettingsCommunicationComponent } from './components/settings-communication/settings-communication.component';
import { PictureComponent } from './components/picture/picture.component';
import { SelectCountryComponent } from './components/select-country/select-country.component';
import { EmailSubscriptionComponent } from './components/email-subscription/email-subscription.component';
import { ReadyToGetStartedComponent } from './components/ready-to-get-started/ready-to-get-started.component';
import { DataConsentRevokeComponent } from './components/data-consent-revoke/data-consent-revoke.component';
import { PriceChangeConsentComponent } from './components/price-change-consent/price-change-consent.component';

// service imports
import { AuthService } from './services/auth/auth.service';
import { ContentfulService } from './services/contentful/contentful.service';
import { ScriptService } from './services/script/script.service';

// pipe imports
import { RichTextToHtmlPipe } from './pipes/rich-text-to-html/rich-text-to-html.pipe';
import { RoundPipe } from './pipes/round/round.pipe';
import { SortByDatePipe } from './pipes/sort-by-date/sort-by-date.pipe';
import { FindResourcePipe } from './pipes/find-resource/find-resource.pipe';

// interface imports
import { WindowWithEarth } from './interfaces/globe';
import { LottiePlayer } from 'ngx-lottie/src/symbols';
import { NavigationModule } from '../../src/app/features/navigation/navigation.module';
import { FooterModule } from '../../src/app/features/footer/footer.module';
import { DynamicFormModule } from '../../src/app/features/dynamic-form/dynamic-form.module';

registerLocaleData(localeFi, 'fi');

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
};

declare global {
  // tslint:disable-next-line: no-empty-interface
  interface Window extends WindowWithEarth {}
}

export function playerFactory(): LottiePlayer {
  return player;
}

@NgModule({
  declarations: [
    OldViewComponent,
    CheckoutJoinComponent,
    CheckoutLoginComponent,
    CheckoutPayComponent,
    CheckoutSidebarComponent,
    CheckoutThankYouComponent,
    ChoosePlanComponent,
    CompleteProfileComponent,
    CurrentPlanComponent,
    DefaultPaymentMethodComponent,
    DefaultPaymentMethodComponent,
    FaqComponent,
    // NavigationComponent,
    // FooterComponent,
    ForgotPasswordComponent,
    HeroComponent,
    HeroImpactComponent,
    HeroImageAndTitleComponent,
    HeroProfileComponent,
    HeroResultsComponent,
    HowCompensateWorksComponent,
    IconTitleIngressAndCtaComponent,
    InviteComponent,
    InvitedByComponent,
    JoinComponent,
    LoginComponent,
    PasswordResetComponent,
    PayComponent,
    ProfileComponent,
    RegisterComponent,
    ResultComponent,
    RichTextToHtmlPipe,
    RoundPipe,
    SettingsComponent,
    SettingsSubscriptionComponent,
    SettingsYourInformationComponent,
    ShareLinkComponent,
    ShareResultComponent,
    SignInComponent,
    SignOutComponent,
    SitraBannerComponent,
    SortByDatePipe,
    TestIntroComponent,
    TestResultCategoryChartComponent,
    TestResultProfileComponent,
    TitleAndIngressBannerComponent,
    UpdatePasswordComponent,
    InternationalTestComponent,
    QuestionComponent,
    ChartComponent,
    SettingsCommunicationComponent,
    FindResourcePipe,
    PictureComponent,
    SelectCountryComponent,
    EmailSubscriptionComponent,
    ReadyToGetStartedComponent,
    DataConsentRevokeComponent,
    PriceChangeConsentComponent,
    UserManagementComponent,
  ],
  imports: [
    CommonModule, // BrowserModule.withServerTransition({ appId: 'compensate' }),
    OldViewRoutingModule,
    // TransferHttpCacheModule,
    // BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    SwiperModule,
    NgxChartsModule,
    HttpClientModule,
    NgSelectModule,
    UiSwitchModule,
    NguCarouselModule,
    LottieModule.forRoot({ player: playerFactory }),
    NavigationModule,
    FooterModule,
    DynamicFormModule,
  ],
  providers: [
    AuthService,
    ContentfulService,
    ScriptService,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
    FindResourcePipe,
  ],
})
export class OldViewModule {}
